/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Offline_License_Invalid_ToastInputs */



/**
* | output |
* | --- |
* | "Offline license is expired or invalid" |
*
* @param {Creator_Offline_License_Invalid_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_offline_license_invalid_toast = /** @type {((inputs?: Creator_Offline_License_Invalid_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Offline_License_Invalid_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La licence hors ligne est expiree ou invalide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Offline-Lizenz ist abgelaufen oder ungültig.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La licenza offline è scaduta o non è valida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Срок действия офлайн-лицензии истек или она недействительна.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La licencia sin conexión ha expirado o no es válida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线许可证已过期或无效")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインライセンスが期限切れまたは無効です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन लाइसेंस की समय सीमा समाप्त हो गई है या वह अमान्य है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A licença offline expirou ou é inválida.")
	return /** @type {LocalizedString} */ ("Offline license is expired or invalid")
});